import React from 'react'
import NumericInput from 'react-numeric-input2';
import classnames from 'classnames'

import { formatClassNames } from '../../utilities'

import './NumberInput.css'

export default function NumberInput(props) {
  const {
    name,
    value,
  } = props

  const classNames = classnames('number-input', formatClassNames(name), {off: ~~value === -1})

  return (
    <div className={classNames}>
      <NumericInput
        {...props}
        noStyle
        onFocus={ e => e.target.select() }
      />
    </div>
  )
}
